
export default function initFavorites(){
	const storageKey = 'cr-favorites';
	const favorites = JSON.parse(localStorage.getItem(storageKey)) || [];

	const updateFavorites = () => {
		localStorage.setItem(storageKey, JSON.stringify(favorites));

		const event = new CustomEvent('localStorageChange', { detail: { storageKey, favorites } });
		window.dispatchEvent(event);
	};

	const addFavorite = (id) => {
		if(!favorites.includes(id)){
			favorites.push(id);
			updateFavorites();
		}
	};

	const removeFavorite = (id) => {
		const index = favorites.indexOf(id);
		if (index > -1) {
			favorites.splice(index, 1);
			updateFavorites();
		}
	};

	const setupFavoriteEl = (el) => {
		if(!el._favoriteHandlerSet){
			el._favoriteHandlerSet = true;
			el.addEventListener('click', (e) => {
				e.preventDefault();
				
				let action, isFavorited;
				
				if(el.classList.contains('is-favorite')){
					removeFavorite(el.dataset.id);
					el.querySelector('span.sr-only').textContent = 'CLICK TO FAVORITE';
					action = 'remove';
					isFavorited = false;
				}else{
					addFavorite(el.dataset.id);
					el.querySelector('span.sr-only').textContent = 'CLICK TO UNFAVORITE';
					action = 'add';
					isFavorited = true;
				}

				// Track favorite action in Google Analytics
				if (typeof gtag !== 'undefined') {
					gtag('event', 'favorite_toggle', {
						item_id: el.dataset.id,
						item_title: el.dataset.title || el.getAttribute('aria-label') || 'Unknown Item',
						favorite_action: action,
						is_favorited: isFavorited,
						context: 'favorite_interaction'
					});
				}

				el.classList.toggle('is-favorite');
			});
		}
	};

	document.querySelectorAll('.js-favorite-btn').forEach(el => {
		if(favorites.includes(el.dataset.id)){
			el.classList.add('is-favorite');
			el.querySelector('span.sr-only').textContent = 'CLICK TO UNFAVORITE';
		}
		setupFavoriteEl(el);
	});

	new MutationObserver(() => {
		document.querySelectorAll('.js-favorite-btn').forEach(el => {
			if(favorites.includes(el.dataset.id)){
				el.classList.add('is-favorite');
			}
			setupFavoriteEl(el);
		});
	}).observe(document.body, {
		childList: true,
		subtree: true
	});
}
